import cx from "classnames";
import TextareaAutosize from "react-textarea-autosize";
import FieldWrapper from "../components/FieldWrapper";
import { TextAreaFieldType } from "../types/feedbackFields.types";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";

// TODO: input mask
// <% if (field.inputMask) { %> data-inputmask="<%= field.inputMask %>"<% } %>

const TextAreaField = ({ field, value, error, onChange }: { field: TextAreaFieldType } & FieldValueProps<string>) => {
  const { _id, name, placeholder, required } = field;
  const id = _id || name;
  return (
    <FieldWrapper field={field} error={error}>
      <TextareaAutosize
        id={id}
        className={cx({ error })}
        placeholder={placeholder}
        name={id}
        rows={2}
        onChange={(e) => onChange(id, e.target.value)}
        value={value || ""}
        required={required}
      />
    </FieldWrapper>
  );
};
export default withSingleValue(TextAreaField);
